<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <!--<div class="option-wrap">-->
      <!--<Button type="primary" @click="newAlert"><Icon type="md-add" size="15" /> 添加应用</Button>-->
    <!--</div>-->
    <!--<Table :loading="tableLoading" class="spacingTwice" border :columns="columns" :data="dataList"></Table>-->
    <!--<Page v-show="total > 10" show-total :total="total" :current="current" :page-size="pageSize"-->
          <!--@on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />-->
    <div class="app-list">
      <Card class="app-item" v-for="(item, index) in dataList" :key="index">
        <div class="text-center">
          <div class="app-info">
            <img :src="item.icon">
            <h3>{{item.name}}</h3>
            <p>{{formatDay(new Date(item.updated_at * 1000), '-')}}</p>
          </div>
          <div class="app-option">
            <div class="option-item" @click="newAlert(index)">
              <div class="item-icon"><Icon size="25" type="md-create" /></div>
              <p>编辑</p>
            </div>
            <div class="option-item" @click="onCopy(item.appid)">
              <div class="item-icon"><Icon size="25" type="md-key" /></div>
              <p>查看AppID</p>
            </div>
            <div class="option-item" @click="delItem(index)">
              <div class="item-icon" style="background-color: #ed4014"><Icon size="25" type="md-close" /></div>
              <p>删除</p>
            </div>
          </div>
        </div>
      </Card>
      <Card class="app-item">
        <div class="app-add" @click="newAlert">
          <Icon type="md-add" size="100" />
          <p>添加新应用</p>
        </div>
      </Card>
    </div>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="newdata"
      title="新建小程序"
      :loading="loading"
      @on-ok="editData('formValidate')">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="小程序名称" prop="name">
          <Input v-model="formValidate.name" placeholder="请输入小程序名称，2-20个字" />
        </FormItem>
        <FormItem label="系统类型" prop="package_type">
          <RadioGroup v-model="formValidate.package_type">
            <Radio :disabled="!!editId" label="android"></Radio>
            <Radio :disabled="!!editId" label="ios"></Radio>
            <Radio :disabled="!!editId" label="wechat">微信小程序</Radio>
          </RadioGroup>
          <div class="tips">创建后不可修改。</div>
        </FormItem>
        <FormItem label="小程序包名" prop="package_name">
          <Input v-model="formValidate.package_name" :readonly="!!editId" placeholder="请输入小程序包名，创建后不可修改。小程序SDK会校验包名是否一致" />
          <div class="tips">创建后不可修改。</div>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="formValidate.remark" type="textarea" :rows="4" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import https from '../https'
import utils from '../utils'
export default {
  name: 'mobileApp',
  data () {
    return {
      loading: true,
      tableLoading: true,
      newdata: false,
      authorized: false,
      selectItems: [],
      sdkVersion: [],
      editId: '',
      formValidate: {
        name: '',
        remark: '',
        package_type: 'android',
        package_name: '',
        package_ver: '1.0.0'
      },
      ruleValidate: {
        name: [
          { required: true, message: '请输入应用名称', trigger: 'blur' },
          { type: 'string', max: 20, min: 2, message: '请输入2-20个字', trigger: 'blur' }
        ],
        package_name: [
          { required: true, message: '请输入应用包名', trigger: 'blur' }
        ],
        package_type: [
          { required: true, message: '请选择系统类型' }
        ]
      },
      dataSource: [], // table数据源
      columns: [ // table表格
        {
          title: 'ID',
          key: 'id',
          width: 100,
          align: 'center',
          fixed: 'left'
        },
        {
          title: 'AppID',
          key: 'appid',
          width: 200,
          align: 'center'
        },
        {
          title: '应用名称',
          key: 'name',
          minWidth: 200
        },
        {
          title: '应用包名',
          key: 'package_name',
          align: 'center',
          width: 200
        },
        {
          title: '秘钥',
          key: 'appkey',
          align: 'center',
          width: 200
        },
        {
          title: '备注',
          key: 'remark',
          minWidth: 300
        },
        {
          title: '操作',
          width: 120,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.delItem(params.index)
                  }
                }
              }, '删除')
            ])
          }
        }
      ],
      tvpList: [],
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 100, // 每页多少条
      current: 1 // 当前页
    }
  },
  components: {
    breadcrumb
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.loadData()
  },
  methods: {
    formatDay: utils.formatDay,
    // 加载tabs列表
    loadData () {
      let params = {
        page_size: this.pageSize,
        page: this.current
      }
      https.request({
        method: 'get',
        url: '/v1/application/list',
        params: params
      }).then(res => {
        this.tableLoading = false
        res.data.list.forEach(n => {
          if (n.package_type === 'android') n.icon = '/static/images/android.png'
          if (n.package_type === 'ios') n.icon = '/static/images/ios.png'
          if (n.package_type === 'wechat') n.icon = '/static/images/wechat.png'
        })
        this.dataList = res.data.list
        this.total = res.data.count
        // this.setData()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    // 数据静态分页
    setData () {
      this.dataList = []
      this.total = this.dataSource.length
      for (let i = (this.current - 1) * this.pageSize; i < this.current * this.pageSize; i++) {
        if (i === this.total) return false
        this.dataList.push(this.dataSource[i])
      }
    },
    // 表格排序
    sortChange (data) {
      if (data.order !== 'normal') {
        this.sort = [data.key, data.order].join(' ')
        this.loadData()
      }
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    // 每页条数控制
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    onCopy (data) {
      this.$copyText(data).then(() => {
        this.$Notice.success({
          title: '已复制到剪贴板',
          desc: `AppID:${data}`
        })
      }, e => {
        console.log(e)
      })
    },
    newAlert (index) {
      this.$refs['formValidate'].resetFields()
      if (!isNaN(index)) {
        this.formValidate = {
          name: this.dataList[index].name,
          remark: this.dataList[index].remark,
          package_type: this.dataList[index].package_type,
          package_name: this.dataList[index].package_name,
          package_ver: '1.0.0'
        }
        this.editId = this.dataList[index].id
      } else {
        this.editId = ''
      }
      this.newdata = true
    },
    editData (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.changeLoading()
            let params = {
              name: this.formValidate.name,
              remark: this.formValidate.remark,
              package_type: this.formValidate.package_type,
              package_name: this.formValidate.package_name,
              package_ver: this.formValidate.package_ver
            }
            let url = '/v1/application/add'
            if (this.editId) {
              url = '/v1/application/edit'
              params.id = this.editId
            } else {
              url = '/v1/application/add'
            }
            https.request({
              method: 'post',
              url,
              data: params
            }).then(res => {
              this.$Message.success('提交成功')
              this.newdata = false
              this.loadData()
            }).catch(error => {
              this.$Message.error(error)
            })
          }, 1000)
        } else {
          this.changeLoading()
        }
      })
    },
    delItem (index) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p class="del-modal-txt">确定要删除 <span>' + this.dataList[index].name + '</span> 吗？</p>',
        onOk: () => {
          https.request({
            method: 'GET',
            url: '/v1/application/del',
            params: {
              id: this.dataList[index].id
            }
          }).then(res => {
            this.$Message.success('删除成功')
            if (this.dataList.length === 1 && this.current > 1) this.current -= 1
            this.loadData()
          }).catch(error => {
            this.$Message.error(error)
          })
        }
      })
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .file-wrap {
    position: relative;
    display: inline-block;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/mobileApp.vue